import React, { useState } from 'react';
import config from '../config/config';
import TermsAndConditions from './TermsAndConditions';
import TermsAndServicesType from '../models/terms';
import getSubdomain from '../utils/getSubdomain';
import { useGetBusinessBySubdomainQuery } from '../store';
import Image from './atoms/Image';
import AvanttiIcon from './icons/AvanttiIcon';

const Footer: React.FC = () => {
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const subdomain = getSubdomain();
  const { data: business, isLoading: isLoadingBusiness } = useGetBusinessBySubdomainQuery(subdomain || '', { skip: !subdomain });

  const handleClickSellAvantti = () => {
    window.open('https://organizadores.avantti.io/', '_blank');
  };

  const handleClickHelp = () => {
    window.open('https://wa.me/message/GV2TPBX7VGT5A1', '_blank');
  };

  return (
    <>
      <div className="flex flex-col py-12 px-4 flex-col justify-between items-center gap-8 bg-neutral-900 text-white border-t border-border-tertiary">
        <div className='flex flex-col lg:flex-row items-center px-4 gap-6 self-stretch justify-between'>
          <div className="flex flex-row justify-center lg:justify-start w-full">
            {!business?.is_white_label && <AvanttiIcon className="inline-block mr-3 text-white" />}
            {business?.is_white_label && <Image
              isDownloading={isLoadingBusiness}
              src={business.logo}
              className="mr-3"
              alt="Business logo"
              height={40}
              width={120}
            />}
          </div>
          <div className="flex flex-col lg:flex-row items-center gap-3 w-full justify-center whitespace-nowrap">
            {((business && business?.is_white_label === false) || !business) && <a className="cursor-pointer" onClick={() => handleClickSellAvantti()}>
              Quiero vender con avantti
            </a>}
            <div><a className="cursor-pointer" onClick={() => handleClickHelp()}>Ayuda</a></div>
            <div>
              <a className="cursor-pointer" onClick={() => setTermsModalOpen(true)}>
                Términos y condiciones
              </a>
            </div>
          </div>
          {((business && business?.is_white_label === false) || !business) && <div className="flex justify-center lg:justify-end items-center gap-6 w-full">
            <div>
              <a href="https://www.instagram.com/avantti.io/"><img src="/instagram-logo.svg" alt="Instagram" /></a>
            </div>
            <div>
              <a href="https://www.facebook.com/people/Avantti/61561762903235/"><img src="/facebook-icon.svg" alt="Facebook" /></a>
            </div>
            <div>
              <a href="https://www.linkedin.com/company/avantti-io"><img src="/linkedin-logo.svg" alt="Linkedin" /></a>
            </div>
            <div>
              <a href="https://organizadores.avantti.io/"><img src="/web-icon.svg" alt="Website" /></a>
            </div>
          </div>}
        </div>
        <div className="flex flex-col items-center text-xs text-white opacity-60 mt-3 font-light">
          <div>©Copyright @ 2025 avantti.io</div>
          <div>All rights reserved.</div>
          <div className="text-xs absolute left-9">v{config.version}</div>
        </div>
      </div>

      <TermsAndConditions
        isOpen={termsModalOpen}
        onClose={() => setTermsModalOpen(false)}
        type={TermsAndServicesType.BUYER}
      />
    </>
  );
};

export default Footer;
